<script setup>
import DefaultLayout from './DefaultLayout.vue';
import AuthLayout from './AuthLayout.vue';
import SimpleLayout from './SimpleLayout.vue';
import BlankLayout from './BlankLayout.vue';
import useSharedStore from '@/presentation/store/shared';

const route = useRoute();
const sharedStore = useSharedStore();

const layout = shallowRef(null);

const layouts = {
	Default: DefaultLayout,
	Auth: AuthLayout,
	Simple: SimpleLayout,
	Blank: BlankLayout,
};

const isBusinessProfileOwner = computed(() => {
	if (route.name !== 'ProfileShopId' || sharedStore.userInformation?.role !== 'Business') return false;

	const shopId = String(route.params.shopId || '');
	const ownerIds = [sharedStore.businessInfo?.id, sharedStore.businessInfo?.businessId, sharedStore.userInformation?.userId].filter(Boolean).map(String);

	return ownerIds.includes(shopId);
});

const layoutName = computed(() => {
	if (isBusinessProfileOwner.value) return 'Default';

	return route.meta.layout || 'Default';
});

const renderComponent = (layoutName = 'Default') => {
	layout.value = layouts[layoutName];
};

watch(layoutName, renderComponent, { immediate: true });
</script>

<template>
	<component :is="layout">
		<slot />
	</component>
</template>
